import { useEffect, useState } from "react";

let webpManifestPromise = null;
let avifManifestPromise = null;

let supportsWebp = null;
let supportsAvif = null;

const testImageFormat = async (type) => {
  if (typeof document === "undefined") return false;

  const canvas = document.createElement("canvas");

  if (!canvas || !canvas.getContext) return false;

  const support = canvas.toDataURL(`image/${type}`).indexOf(`data:image/${type}`) === 0;

  return support;
};

export const Image = ({ src, alt = "",onLoad=null, className = "", ...props }) => {
  const [format, setFormat] = useState("original");
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const checkFormats = async () => {
      if (!src || src.endsWith(".svg")) {
        setChecked(true);
        return;
      }

      const relativeSrc = src.startsWith("/") ? src.slice(1) : src;

      if (!webpManifestPromise)
        webpManifestPromise = fetch("/webp-manifest.json").then((res) => res.json());

      if (!avifManifestPromise)
        avifManifestPromise = fetch("/avif-manifest.json").then((res) => res.json());

      const [webpManifest, avifManifest] = await Promise.all([
        webpManifestPromise,
        avifManifestPromise,
      ]);

      if (supportsWebp === null) supportsWebp = await testImageFormat("webp");
      if (supportsAvif === null) supportsAvif = await testImageFormat("avif");
      if (supportsAvif && avifManifest[relativeSrc]) {
        setFormat("avif");
      } else if (supportsWebp && webpManifest[relativeSrc]) {
        setFormat("webp");
      } else {
        setFormat("original");
      }

      setChecked(true);
    };

    checkFormats();
  }, [src]);

  if (!src || (!checked && !src.endsWith(".svg"))) return null;

  const ext = src.match(/\.(jpg|jpeg|png)$/i)?.[0] || "";
  const base = src.slice(0, -ext.length);

  return format !== "original" ? (
    <div className={className}>
      <picture>
        {format === "avif" && <source srcSet={`${base}.avif`} type="image/avif" />}
        {format === "webp" && <source srcSet={`${base}.webp`} type="image/webp" />}
        <img src={src} alt={alt} onLoad={onLoad} {...props} />
      </picture>
    </div>

  ) : (
    <div className={className}>
    <img src={src} alt={alt} className={className} {...props}/>
    </div>
  );
};
